'use client';
import React, { useState, useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import styled from '@benzinga/themetron';
import { Input } from 'antd';
import Link from 'next/link';

export interface WorkersCompensationDataFormBlockProps {
  attrs: any;
}

export const WorkersCompensationDataFormBlock: React.FC<WorkersCompensationDataFormBlockProps> = ({ attrs }) => {
  const [rate, setRate] = useState(1.88);
  const [experience, setExperience] = useState(1);
  const [annualPayroll, setAnnualPayroll] = useState(50000);
  const [stateFee, setStateFee] = useState(250);
  const [numberEmp, setNumberEmp] = useState(25);
  const [annualPolicyPremium, setAnnualPolicyPremium] = useState('');
  const [annualPolicyPremiumPerEmployee, setAnnualPolicyPremiumPerEmployee] = useState('');

  const handleRate = event => {
    setRate(event.target.value);
  };
  const handleExperience = event => {
    setExperience(event.target.value);
  };
  const handleAnnualPayroll = event => {
    setAnnualPayroll(event.target.value);
  };
  const handleNumberEmp = event => {
    setNumberEmp(event.target.value);
  };
  const handleStateFee = event => {
    setStateFee(event.target.value);
  };
  useEffect(() => {
    const result = rate * experience * (annualPayroll / 100) + Number(stateFee);
    const rounded_result = Math.round(result * 100) / 100;
    const annualPolicyPremium = currencyFormat(rounded_result * numberEmp);
    const annualPolicyPremiumPerEmployee = currencyFormat(rounded_result);

    setAnnualPolicyPremium(annualPolicyPremium);
    setAnnualPolicyPremiumPerEmployee(annualPolicyPremiumPerEmployee);
  }, [rate, experience, annualPayroll, stateFee, numberEmp]);
  const currencyFormat = number => {
    const formatter = new Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency',
    });
    return formatter.format(number);
  };

  return (
    <LazyLoad>
      <WorkersCompensationDataFormContainer>
        <div className="calculator-wrapper health-insurance-data-form">
          <div className="health-widget-form-wrapper">
            {attrs.data.title && <h3 className="font-manrope leading-7 text-2xl font-bold">{attrs.data.title}</h3>}
            {attrs.data.subtitle && <div className="mb-4">{attrs.data.subtitle}</div>}
            <div>
              <form id="lemonade-calculator-form">
                <div className="form-field-wrap with-text">
                  <Label>What is your class code rate?</Label>
                  <TextSpan className="input-group-text font-manrope">$</TextSpan>
                  <Input
                    className={!rate ? `m-0 mb-0 font-manrope is-empty ` : `m-0 mb-0 font-manrope`}
                    id="wcd-rate"
                    min="0.00"
                    name="rate"
                    onChange={handleRate}
                    placeholder="Enter Rate"
                    step="0.01"
                    type="number"
                    value={rate}
                  />
                  {!rate && <p className="text-red-500 text-sm">Please fill the field.</p>}
                </div>
                <div className="form-field-wrap">
                  <Label>What is your experience modifier?</Label>
                  <Input
                    className={!experience ? `mb-0 font-manrope is-empty ` : `m-0 mb-0 font-manrope`}
                    id="wcd-experience"
                    min="0"
                    name="experience"
                    onChange={handleExperience}
                    placeholder="Enter Experience"
                    step="1"
                    type="number"
                    value={experience}
                  />
                  {!experience && <p className="text-red-500 text-sm">Please fill the field.</p>}
                </div>
                <div className="form-field-wrap with-text">
                  <Label>What is the average annual payroll per employee?</Label>
                  <TextSpan className="input-group-text font-manrope">$</TextSpan>
                  <Input
                    className={!annualPayroll ? `m-0 mb-0 font-manrope is-empty ` : `m-0 mb-0 font-manrope`}
                    id="wcd-annual-payroll"
                    min="0"
                    name="annual-payroll"
                    onChange={handleAnnualPayroll}
                    placeholder="Enter Annual Payroll"
                    step="1000"
                    type="number"
                    value={annualPayroll}
                  />
                  {!annualPayroll && <p className="text-red-500 text-sm">Please fill the field.</p>}
                </div>
                <div className="form-field-wrap with-text">
                  <Label>What is the State Fee?</Label>
                  <TextSpan className="input-group-text font-manrope">$</TextSpan>
                  <Input
                    className={!stateFee ? `m-0 mb-0 font-manrope is-empty ` : `m-0 mb-0 font-manrope`}
                    id="wcd-state-fee"
                    min="0"
                    name="state-fee"
                    onChange={handleStateFee}
                    placeholder="Enter State Fee"
                    step="10"
                    type="number"
                    value={stateFee}
                  />
                  {!stateFee && <p className="text-red-500 text-sm">Please fill the field.</p>}
                </div>
                <div className="form-field-wrap">
                  <Label>Number of Employees</Label>
                  <Input
                    className={!numberEmp ? `mb-0 font-manrope is-empty ` : `m-0 mb-0 font-manrope`}
                    id="wcd-number-emp"
                    min="0"
                    name="number-emp"
                    onChange={handleNumberEmp}
                    placeholder="Enter Number Employees"
                    step="1"
                    type="number"
                    value={numberEmp}
                  />
                  {!numberEmp && <p className="text-red-500 text-sm">Please fill the field.</p>}
                </div>
                <div className="form-field-wrap mt-4 text-center">
                  <div className="btn-cta">
                    <Link
                      href={
                        attrs.data.go_link
                          ? attrs.data.go_link
                          : `https://business.insurance.thehartford.com/Benzinga?prcd=76210781&Tcode=AF280025&cmp=AF-SC-Benzinga-33486779`
                      }
                    >
                      <a rel="nofollow" target="_blank">
                        Get Started
                      </a>
                    </Link>
                  </div>
                </div>
                {annualPolicyPremiumPerEmployee && annualPolicyPremium && (
                  <div className="font-manrope lemonade-result-wrapper m-0 mt-4 overflow-hidden p-2 rounded">
                    <div className="lemonade-result">
                      <p className="text-lg mb-1.5">
                        Annual Policy Premium: <strong>{annualPolicyPremium}</strong>{' '}
                      </p>
                      <p className="text-sm mb-0">
                        <span>{annualPolicyPremiumPerEmployee + `per employee`} </span>
                      </p>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </WorkersCompensationDataFormContainer>
    </LazyLoad>
  );
};

const TextSpan = styled.span`
  &.input-group-text {
    width: 14%;
    display: inline-block;
    background: #e9ecef;
    height: 39px;
    vertical-align: top;
    line-height: 37px;
    text-align: center;
    color: #495057;
    font-weight: 700;
    font-size: 22px;
    border: 1px solid #cacaca;
    border-radius: 0;
  }
`;
const Label = styled.label`
  display: block;
  margin: 0;
  font-weight: 400;
  line-height: 1.8;
  color: #0a0a0a;
  font-size: 16px;
  margin-bottom: 7px;
`;

const WorkersCompensationDataFormContainer = styled.div`
  [type='month'],
  [type='number'],
  [type='text'] {
    width: 100%;
    height: 2.4375rem;
    margin: 0 0 1rem;
    padding: 0.5rem;
    border: 1px solid #adadad;
    border-radius: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #0a0a0a;
    transition:
      box-shadow 0.5s,
      border-color 0.25s ease-in-out,
      -webkit-box-shadow 0.5s;
    &.is-empty {
      border-color: #ff4050;
      margin-bottom: 5px;
    }
    &:focus {
      box-shadow: unset;
    }
  }

  .health-insurance-data-form {
    max-width: 320px;
    margin: auto;
    &.calculator-wrapper {
      min-width: 320px;
    }
    input {
      &::placeholder {
        color: rgb(129 129 129);
      }
    }
    .btn-cta {
      line-height: 40px;
      border: 0;
      border-radius: 4px;
      color: #fefefe !important;
      font-family: sans-serif;
      white-space: nowrap;
      display: inline-block;
      padding: 0 14px;
      font-weight: 600;
      text-decoration: none;
      font-size: 16px;
      cursor: pointer;
      background-color: #002d45;
      height: 2.5rem;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      width: 100%;
      a {
        font-size: 14px;
        color: #fff;
      }
      &:hover {
        box-shadow:
          0 2px 1px rgb(50 50 93 / 20%),
          0 3px 6px rgb(0 0 0 / 10%);
      }
    }
    .with-text {
      [type='number'] {
        width: 86%;
        display: inline-block;
      }
    }
    .health-widget-form-wrapper {
      background: #fff;
      border: 1px solid #ccc;
      padding: 15px;
      max-width: 100%;
      margin: 40px auto auto;
    }
    .lemonade-result-wrapper {
      background: #ffddc4;
    }
    .bg-blue-light_100 {
      --tw-bg-opacity: 1;
      background-color: #1a79ff;
    }
  }
`;
